import { initGlobalState } from "qiankun";
import store from "../store";
import moment from "moment";

const initialState = {
  ...store.getters, // 从主应用仓库读出的数据
  time: moment().format("yyyy.MM.DD HH:mm:ss")
};
const actions = initGlobalState(initialState);

export default actions;
